import { useNavigate } from "react-router-dom";
import ProfileNavData from "./ProfileNavData.js";
import useUser from "../../hook/useUser.js";
import { MdAccountCircle } from "react-icons/md";

const ProfileNav = () => {
    const navigate = useNavigate();
    const { user, error, loading } = useUser();

    if (loading) return null;

    console.log("user.photo:", user?.photo);

    return (
        <div className="nav profile-nav">
            <div className="nav-wrapper">
                <div className="prof-icon">
                    {user?.photo ? (
                        <img
                            src={user.photo}
                            alt="profile image"
                            className="prof-img"
                        />
                    ) : (
                        <div className="avatar">
                            {user?.name ? user.name.charAt(0).toUpperCase() : <MdAccountCircle />}
                        </div>
                    )}
                </div>
                <div className="user-name">
                    {user ? user.employeeName : "Loading..."}
                </div>
                <div className="user-info">
                    {user ? user.position : "Loading..."}
                </div>
                <div className="user-info">
                    {user ? user.employeeId : "Loading..."}
                </div>
            </div>
            <ul className="nav_list">
                {ProfileNavData.map((value, key) => {
                    return (
                        <li key={key} className="row"
                            onClick={() => navigate(value.link)}
                        >
                            <div className="title">{value.title}</div>
                        </li>
                    );
                })}
            </ul>
        </div >
    );
}

export default ProfileNav;